<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-08-19 00:08:31
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="content">
        <div class="pageTitle">概况</div>
        <el-row :gutter="18">
            <el-col :span="6"><div class="grid-content bg-color">
                <span>经销商总数</span>
                <p>{{dealer_count}}</p>
            </div></el-col>
              <el-col :span="6"><div class="grid-content bg-color">
                <span>直属门店总数</span>
                <p>{{shop_count}}</p>
            </div></el-col>
            <el-col :span="6"><div class="grid-content bg-color">
                <span>商品出货总量</span>
                <p>{{stock_out_num}}</p>
            </div></el-col>
           <!-- <el-col :span="6"><div class="grid-content bg-color">
                <span>商品出货总额</span>
                <p>31234</p>
            </div></el-col>-->
            <el-col :span="6"><div class="grid-content bg-color">
                <span>窜货总数量</span>
                <p>{{feeling_goods_num}}</p>
            </div>
            </el-col>
            <div class="countType">
                <el-button size="mini" @click="countFun('day')">日</el-button>
                <el-button size="mini" @click="countFun('week')">周</el-button>
                <el-button size="mini" @click="countFun('month')">月</el-button>
            </div>
        </el-row>
        <div id="main">
        </div>
       <el-row>
            <el-col :span="12" style="border:1px solid #ccc"><div class="block bg-color">
                <span>效期提醒
                     <span class='tipsIcon'>?</span>
                    <div class='text'>统计本周，本月，本季度即将过去产品</div>
                </span>
            </div></el-col>
            <el-col :span="12"  style="border:1px solid #ccc" ><div class="block bg-color">
                <span>效期品数量: {{expiry_date.expiry_all_total}}</span>
            </div></el-col>
        </el-row>
        <el-table
                :data="expiry_date.expiry_dates"
                border
                stripe>
            <el-table-column
                    prop="product_name"
                    label="产品名称"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="production_batch"
                    label="批号"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="expiry_week_total"
                    label="本周">
                <template slot="header" slot-scope="scope">
                <div style="display:block">本周</div>
                <span>{{weeks}}</span>
            </template>
            </el-table-column>
            <el-table-column
                    prop="expiry_month_total"
                    label="本月">
                         <template slot="header" slot-scope="scope">
                <div style="display:block">本月</div>
                <span>{{months}}</span>
            </template>
            </el-table-column>
            <el-table-column
                    prop="expiry_quarter_total"
                    label="本季度">
                             <template slot="header" slot-scope="scope">
                <div style="display:block">本季度</div>
                <span>{{quarter}}</span>
            </template>
            </el-table-column>
        </el-table>
          <router-link to='Dealerstock?tab=5' tag='div' style='text-align:right;color:#666;font-size:13px;padding:8px 0'>
            <span>更多</span>
        </router-link>
        <el-row style="margin: 20px 0px">
            <el-col :span="12" style="border:1px solid #ccc"><div class="block bg-color">
                <span>呆滞品提醒
                        <span class='tipsIcon'>?</span>
                    <div class='text'>统计从客户入库到今天,大于{{dead_Num}}天未销售出去的产品</div>
                </span>
            </div></el-col>
            <el-col :span="12"  style="border:1px solid #ccc" ><div class="block bg-color">
                <span>呆滞品数量: {{dead_stock.dead_stock_total}}</span>
            </div></el-col>
        </el-row>
        <el-table
                :data="dead_stock.dead_stocks"
                stripe>
            <el-table-column
                    prop="product_name"
                    label="产品名称"
                   >
            </el-table-column>
            <el-table-column
                    prop="production_batch"
                    label="批号"
                    >
            </el-table-column>
            <el-table-column
                    prop="dead_stock_num"
                    label="呆滞品数量">
            </el-table-column>
        </el-table>
        <router-link  to='/Dealerstock?tab=4' tag='div' style='text-align:right;color:#666;font-size:13px;padding:8px 0'>
            <span>更多</span>
        </router-link>
    </div>
</template>

<script>
    import echarts from 'echarts'
    export default {
        name: "survey",
        data() {
            return {
                tableData: [],
                charts: '',
                option: {
                    title: {      //标题组件
                        text: '出货数量趋势图'
                    },
                    tooltip: {    //提示框组件
                        trigger: 'axis'
                    },
                    legend: {     //图例组件
                        data: ['出货数量'],
                        left:200
                    },
                    grid: {       //直角坐标系内绘图网格
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    toolbox: {     //工具栏
                        feature: {
                        }
                    },
                    xAxis: {       //直角坐标系 grid 中的 x 轴
                        type: 'category',
                        boundaryGap: false,
                        data: []
                    },
                    yAxis: {       //直角坐标系 grid 中的 y 轴
                        type: 'value'
                    },
                    series: [      //系列列表
                        {
                            name: '出货数量',
                            type: 'line',
                            stack: '总量',
                            data: []
                        }
                    ]
                },
                home_type:'day',
                dealer_count:'',
                feeling_goods_num:'',
                stock_out_num:'',
                dataArr:[],
                numberArr:[],
                shop_count:0,
                expiry_date:[],
                dead_stock:[],
                dead_Num:0,
                weeks:0,
                months:0,
                quarter:0,

            }
        },
        methods: {
            // 获取呆滞品天数
            getConf(){
                
                  this.$get('logistics','/configs').then(res => {
                        this.dead_Num=res.data.dead_stock
                }).catch(error => {
                    this.$message({
                        type: 'error',
                        message: error.message
                    });
                    console.log(error);
                });
            },
            // 获取日期
            getDate(){
                 // 获取周
                 var Nowdate=new Date();     
                     var WeekFirstDay=new Date(Nowdate-(Nowdate.getDay()-1)*86400000);
                      var WeekLastDay=new Date((WeekFirstDay/1000+6*86400)*1000);     
                 var M=Number(WeekFirstDay.getMonth())+1
                this.weeks=M+"-"+WeekFirstDay.getDate()+'至'+M+"-"+WeekLastDay.getDate()    
            
    // 获取月
                 var MonthNextFirstDay=new Date(Nowdate.getYear(),Nowdate.getMonth()+1,1);     
                  var MonthLastDay=new Date(MonthNextFirstDay-86400000);     
                 M=Number(MonthLastDay.getMonth())+1  
                 this.months=M+"-"+MonthNextFirstDay.getDate()+ '至'+ M+"-"+MonthLastDay.getDate()
                // 获取季度
                  var quarterEndMonth = this.getQuarterStartMonth(M) + 2;
                 var quarterStartDate = new Date(Nowdate.getYear(), quarterEndMonth, this.getMonthDays(Nowdate.getYear(),quarterEndMonth));
                    this.formatDate(quarterStartDate);
                    this.quarter=this.formatDate(new Date(Nowdate.getYear(),this.getQuarterStartMonth(M), 1))+'至'+this.formatDate(quarterStartDate)
            },
       getMonthDays(ye,myMonth){
        var monthStartDate = new Date(ye, myMonth, 1);
        var monthEndDate = new Date(ye, myMonth + 1, 1);
        var days = (monthEndDate - monthStartDate)/(1000 * 60 * 60 * 24);
        return days;
    },
              //获得本季度的开端月份
     getQuarterStartMonth(nowMonth){
        var quarterStartMonth = 0;
        if(nowMonth<3){
            quarterStartMonth = 0;
        }
        if(2<nowMonth && nowMonth<6){
            quarterStartMonth = 3;
        }
        if(5<nowMonth && nowMonth<9){
            quarterStartMonth = 6;
        }
        if(nowMonth>8){
            quarterStartMonth = 9;
        }
        return quarterStartMonth;
    },
             formatDate(date) {
        var myyear = date.getFullYear();
        var mymonth = date.getMonth()+1;
        var myweekday = date.getDate();
 
        if(mymonth < 10){
            mymonth = "0" + mymonth;
        }
        if(myweekday < 10){
            myweekday = "0" + myweekday;
        }
        return (mymonth + "-" + myweekday);
    },
            //请求数据
            getData(){
                this.$get('logistics','/home', {
                    lang:'',
                    home_type:this.home_type
                }).then(res => {
                    this.dealer_count = res.data.dealer_count;
                    this.feeling_goods_num =res.data.feeling_goods_num;
                    this.stock_out_num = res.data.stock_out_num;
                    this.shop_count=res.data.shop_count
                    this.dead_stock=res.data.dead_stock
                    for (var i = 0; i < res.data.statistics_data.length; i++) {
                        this.option.xAxis.data.push(res.data.statistics_data[i].name);
                        this.option.series[0].data.push(res.data.statistics_data[i].stock_out_num);
                    }
                    this.charts.setOption(this.option)
                    this.expiry_date=res.data.expiry_date
                }).catch(error => {
                    this.$message({
                        type: 'error',
                        message: error.message
                    });
                    console.log(error);
                });
            },
            countFun(type){
                console.log(type);
                this.home_type = type;
                this.option.xAxis.data = [];
                this.option.series[0].data = [];
                this.getData();

            },
            //echart
            drawLine(id){
                this.charts = echarts.init(document.getElementById(id))
                this.charts.setOption(this.option)
            }
        },
        created(){
        
            this.getData();
            this.getConf()
            this.getDate()
        },
        mounted() {
            this.$nextTick(function() {
                this.drawLine('main');
            })
        },
    }
</script>

<style lang="scss" scoped>
    .content {
        height: 100%;
        padding: 20px;
        position: relative;
        .countType{
            z-index: 99999;
            height: 40px;
            width: 200px;
            position: absolute;
            right:0;
            bottom:-60px;
        }
        .el-row {
            margin-bottom: 20px;
            &:last-child {
                margin-bottom: 0;
            }
        }
        .el-col {
            border-radius: 4px;
        }
        .bg-color {
            background: #fff;
        }
        .grid-content {
            border-radius: 4px;
            border: 1px solid #ccc;
            min-height: 160px;
            span{
                padding: 15px;
                display: block;
                height: 20px;
                line-height: 20px;
                border-bottom: 1px solid #ccc;
            }
            p{
                padding: 36px 15px;
                font-size: 32px;
            }
        }
        .row-bg {
            padding: 10px 0;
            background-color: #f9fafc;
        }
        #main{
            width: 100%;
            height: 500px;
        }
        .block{
            box-sizing: border-box;
            border-radius: 4px;
            min-height: 70px;
            text-align: center;
            line-height: 70px;
            span{
                font-size: 24px;
            }
        }
    }
.block {
    position: relative;
}
.tipsIcon{
  display: inline-block;
  width:20px;
  height: 20px;
  background-color: rgb(65, 68, 78);
  border-radius: 50%;
  color: #fff;
  line-height: 20px;
  text-align: center;
  margin-left: 10px;
  
}
.tipsIcon:hover~.text{
  opacity: 1;
  display: block;
  
}
.text{
//   width: 300px;
  position: absolute;
  background-color: rgb(65, 68, 78);
  color: #fff;
  z-index: 1000;
  border-radius: 25px;
  padding:0 5px;
  right: 10%;
  bottom:-70px;
  font-size: 14px;
  height: auto;
  opacity: 0;
  display: none;
}
.text::before{
  width: 20px;
  height: 20px;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color:#fff;
}
</style>

